import { z } from 'zod'
import {
  GatewaySchema,
  InvoiceStatusSchema,
  PaymentMethodSchema,
  ReceivingPeriodSchema,
  SubscriptionStatusSchema,
} from '@shared/contracts/enums'
import { MonetaryValueSchema } from '@shared/lib/money/money'

export const SubscriptionSchema = z.object({
  commercialAmount: MonetaryValueSchema.optional(),
  id: z.string(),
  planId: z.string(),
  planName: z.string().optional(),
  productId: z.string(),
  productName: z.string().optional(),
  producerId: z.string(),
  sellerId: z.string(),
  buyerId: z.string().optional(),
  buyerEmail: z.string().optional(),
  buyerName: z.string().optional(),
  initialSaleId: z.string(),
  initialPaymentSaleId: z.string().optional(),
  status: SubscriptionStatusSchema,
  currentPeriodStartAt: z.string(),
  currentPeriodEndAt: z.string(),
  gateway: GatewaySchema,
  receivingPeriod: ReceivingPeriodSchema,
  paymentMethod: PaymentMethodSchema,
  chargeAmount: MonetaryValueSchema.optional(),
  settlementAmount: MonetaryValueSchema.optional(),
  recurringAmount: MonetaryValueSchema.optional(),
  affiliateId: z.string().optional(),
  affiliatePercentage: z.string().optional(),
  coProducerId: z.string().optional(),
  coProducerPercentage: z.string().optional(),
  seedId: z.string().optional(),
  seedPercentage: z.string().optional(),
  affiliateRecurring: z.boolean(),
  conversionSettledAt: z.string().optional(),
  canceledAt: z.string().optional(),
  cancellationReason: z.string().optional(),
  cancelAtPeriodEnd: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
  viewerRole: z.enum(['PRODUCER', 'AFFILIATE', 'COPRODUCER']).optional(),
  viewerCanManage: z.boolean().optional(),
})

export const SubscriptionListSchema = z.object({
  items: z.array(SubscriptionSchema),
  nextOffset: z.number().nullable().optional().default(null),
  hasMore: z.boolean().optional().default(false),
})

export const SubscriptionInvoiceSchema = z.object({
  paidAmount: MonetaryValueSchema.optional(),
  id: z.string(),
  subscriptionId: z.string(),
  initialSaleId: z.string(),
  cycleN: z.number(),
  value: MonetaryValueSchema,
  chargeAmount: MonetaryValueSchema.optional(),
  settlementAmount: MonetaryValueSchema.optional(),
  status: InvoiceStatusSchema,
  dueAt: z.string(),
  paidAt: z.string().optional(),
  attempts: z.number(),
  attemptSeq: z.number(),
  lastAttemptAt: z.string().optional(),
  nextAttemptAt: z.string().optional(),
  gracePeriodEndsAt: z.string().optional(),
  settlementSaleId: z.string(),
  gatewayPaymentId: z.string().optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
})

export const SubscriptionInvoiceListSchema = z.object({
  items: z.array(SubscriptionInvoiceSchema),
})

export type Subscription = z.infer<typeof SubscriptionSchema>
export type SubscriptionList = z.infer<typeof SubscriptionListSchema>
export type SubscriptionInvoice = z.infer<typeof SubscriptionInvoiceSchema>
export type SubscriptionInvoiceList = z.infer<typeof SubscriptionInvoiceListSchema>
